import Vue from "vue"
import VueRouter from "vue-router"
import Account from "../page/Account.vue"
import Login from "../page/Login.vue"
import Underage from "../page/Underage.vue"
import Verify from "../page/Verify.vue"
import Result from "../page/Result.vue"
import Account2 from "../page2/Account.vue"
import Login2 from "../page2/Login.vue"
import Verify2 from "../page2/Verify.vue"
import Result2 from "../page2/Result.vue"

import OauthLogin2 from "../oauth/Login.vue"
import OauthUnderage2 from "../oauth/Underage.vue"
import OauthVerify2 from "../oauth/Verify.vue"
import OauthResult2 from "../oauth/Result.vue"
import OauthCallBack from "../oauth/CallBack.vue"

import OauthFPXLogin2 from "../oauthFPX/Login.vue"
import OauthFPXUnderage2 from "../oauthFPX/Underage.vue"
import OauthFPXVerify2 from "../oauthFPX/Verify.vue"
import OauthFPXResult2 from "../oauthFPX/Result.vue"
import OauthFPXLoginCB from "../oauthFPX/LoginCB.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Account",
    component: Account
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/underage",
    name: "Underage",
    component: Underage,
  },
  {
    path: "/verify",
    name: "Verify",
    component: Verify
  },
  {
    path: "/result",
    name: "Result",
    component: Result
  },
  {
    path: "/oauth",
    name: "OauthLogin",
    component: OauthLogin2,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/oauthU",
    name: "OauthUnderage",
    component: OauthUnderage2,
  },
  {
    path: "/oauthV",
    name: "OauthVerify",
    component: OauthVerify2
  },
  {
    path: "/oauthR",
    name: "OauthResult",
    component: OauthResult2
  },
  {
    path: "/redirect",
    name: "OauthCallBack",
    component: OauthCallBack
  },
  {
    path: "/oauthFPX",
    name: "OauthFPXLogin",
    component: OauthFPXLogin2,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/oauthFPXU",
    name: "OauthFPXUnderage",
    component: OauthFPXUnderage2,
  },
  {
    path: "/oauthFPXV",
    name: "OauthFPXVerify",
    component: OauthFPXVerify2
  },
  {
    path: "/oauthFPXR",
    name: "OauthFPXResult",
    component: OauthFPXResult2
  },
  {
    path: "/oauthFPXCB",
    name: "OauthFPXLoginCB",
    component: OauthFPXLoginCB
  }
]

if (typeof window.qt !== 'undefined') {
  routes.push(
    {
      path: "/account2",
      name: "Account2",
      component: Account2
    },
    {
      path: "/login2",
      name: "Login2",
      component: Login2,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/verify2",
      name: "Verify2",
      component: Verify2
    },
    {
      path: "/result2",
      name: "Result2",
      component: Result2
    }
  )
}

const router = new VueRouter({
  mode: "history",
  routes
})

router.beforeEach((to, from, next) => {
  window.$Spin.hide()
  window.unbindClose && window.unbindClose()
  next()
})

export default router
